import React, { useState, useEffect, useRef } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const PdfCanvasViewer = ({ pdfUrl }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const viewerRef = useRef(null);

    useEffect(() => {
        if (pdfUrl) {
            setTimeout(() => setIsLoaded(true), 100);
        }
    }, [pdfUrl]);

    const handleError = (error) => {
        console.error("Error loading PDF: ", error);
        setHasError(true);
    };

    return (
        <div
            style={{
                height: "auto",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                opacity: isLoaded ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
            }}
        >
            {hasError ? (
                <p>Fehler beim Laden der PDF.</p>
            ) : (
                <Worker workerUrl={`/pdf.worker.min.js`}>
                    <div style={{ transform: "scale(0.85)", transformOrigin: "top center", width: "90%" }} ref={viewerRef}>
                        {isLoaded && pdfUrl && <Viewer fileUrl={pdfUrl} onLoadError={handleError} />}
                    </div>
                </Worker>
            )}
        </div>
    );
};

export default PdfCanvasViewer;